import React, { useCallback } from 'react'
import { Menu, ButtonBase, Tooltip, makeStyles } from '@material-ui/core'
import { MoreHoriz } from '@material-ui/icons'
import { gray } from '../../../utils/colors'
import { FONT_WEIGHTS } from '../../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
		'& .MuiButtonBase-root': {
			'& .MuiSvgIcon-root': {
				fontSize: '1.1rem',
				color: gray[700],
				fill: gray[700]
			}
		}
	},
	button: {
		width: 44,
		height: 44,
		borderRadius: 22
	},
	buttonHover: {
		width: 44,
		height: 44,
		borderRadius: 22,
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.04)'
		}
	}
}))

const MoreMenu = ({ options = [], description = '', useHoverState = false }) => {
	const classes = useStyles()
	const [anchorEl, setAnchorEl] = React.useState(null)
	const open = Boolean(anchorEl)

	const handleClick = useCallback((event) => setAnchorEl(event.currentTarget), [setAnchorEl])
	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleOnClick = useCallback((onClick) => {
		handleClose()
		onClick()
	}, [])

	return (
		<div className={classes.root}>
			<Tooltip title={`Manage ${description}`} placement="right">
				<ButtonBase
					onClick={handleClick}
					classes={{
						root: useHoverState ? classes.buttonHover : classes.button
					}}>
					<MoreHoriz
						style={{
							color: gray[700],
							fontSize: '1.5rem',
							fontWeight: FONT_WEIGHTS.ExtraBold
						}}
					/>
				</ButtonBase>
			</Tooltip>
			<Menu
				id="more-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'more-menu-button'
				}}>
				{options.map((option, i) => {
					const { props } = option
					const { onClick } = props
					const newOption = {
						...option,
						props: {
							...props,
							key: `more-menu-option-${i}`,
							style: { minWidth: '12rem' },
							onClick: () => handleOnClick(onClick)
						}
					}
					return newOption
				})}
			</Menu>
		</div>
	)
}

export default MoreMenu
